










































































import infoBlock from 'src/components/InfoBlock/InfoBlock.vue'
import Vue from 'vue'
import Mailing from '@/models/mailing/mailing'
export default Vue.extend({
  props: {
    scope: {} as () => {mailing: Mailing},
    options: {}
  },
  data () {
    return {}
  },
  components: {
    infoBlock,
  },
  computed: {
    yesno () {
      return this.scope.mailing.getYesNo();
    },
    likes () {
      return this.scope.mailing.getLikes();
    }
  }
})
